import { FC, useState } from 'react';
import {
    AppBar,
    Toolbar,
    Button,
    Checkbox,
    FormControlLabel,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import ClearIcon from '@material-ui/icons/Clear';
import styled from 'styled-components';
import ConfirmDialog from './ConfirmDialog';

const StyledAppBar = styled(AppBar)`
    bottom: 0;
`;

const Controls = styled.div`
    flex: 1;
    text-align: right;
`;

type BottomBarProps = {
    isFilterOn: boolean;
    onResetClick: () => void;
    onMenuClick: () => void;
    onFilterChanged: () => void;
};

const BottomBar: FC<BottomBarProps> = ({
    isFilterOn,
    onResetClick,
    onMenuClick,
    onFilterChanged,
}) => {
    const [modalOpen, setModalOpen] = useState(false);

    const onReset = () => {
        setModalOpen(true);
    };

    const onConfirmDialog = () => {
        onResetClick();
        setModalOpen(false);
    };

    const onCancelDialog = () => {
        setModalOpen(false);
    };

    return (
        <>
            <StyledAppBar position="sticky">
                <Toolbar>
                    <Button
                        color="inherit"
                        startIcon={<MenuIcon />}
                        onClick={onMenuClick}
                    >
                        Menu
                    </Button>
                    <Controls>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isFilterOn}
                                    onChange={onFilterChanged}
                                    name="filter"
                                />
                            }
                            label="Unchecked Only"
                        />
                        <Button
                            color="inherit"
                            startIcon={<ClearIcon />}
                            onClick={onReset}
                        >
                            Reset
                        </Button>
                    </Controls>
                </Toolbar>
            </StyledAppBar>
            <ConfirmDialog
                open={modalOpen}
                title="Reset Checklist"
                content={
                    <>
                        <p>Are you sure you want to reset the checklist ?</p>
                        <p>This action cannot be reverted.</p>
                    </>
                }
                onConfirm={onConfirmDialog}
                onCancel={onCancelDialog}
            />
        </>
    );
};

export default BottomBar;
